import Vue from 'vue'
import Vuex from 'vuex'

import User from './modules/user'
import Programari from './modules/programari'
import Pacienti from './modules/pacienti'
import Interventii from './modules/interventii'
import Profil from './modules/profil'
import App from './modules/app'

const actions = {}
const getters = {}
const mutations = {}
const state = {}

Vue.use(Vuex)

export default new Vuex.Store({
  actions,
  getters,
  modules: {
    User,
    Programari,
    Pacienti,
    Interventii,
    Profil,
    App
  },
  mutations,
  state
})



// WEBPACK FOOTER //
// ./src/store/index.js